import React from 'react';
import type { JsonLandingPage } from '@sy/ssr-types';
import BlogsBlock from '~/templates/LandingV2/components/BlogsBlock';
import SignupEmailPage from '~/scenes/Signup/scenes/SignupEmailPage';
import { CTARow } from '~/components/Marketing';
import { Translation } from '~/components/Translation';
import HeroSection from './components/HeroSection';
import MainImages from './components/MainImages';
import ComparisonHeader from './components/ComparisonHeader';
import ComparisonColumns from './components/ComparisonColumns';
import TableComparison from './components/TableComparison';

interface StreamYardVsCompetitorProps {
	data: JsonLandingPage;
}

const StreamYardVsCompetitor: React.FC<StreamYardVsCompetitorProps> = ({
	data,
}) => {
	const { content } = data;
	const { competitor, fullCompetitorName } = content;

	return (
		<div className="streamyard-vs-competitor-landing-page">
			{content.hero && (
				<HeroSection
					titleKey={content.hero.titleKey}
					subtitleKey={content.hero.subtitleKey}
					competitor={competitor}
				/>
			)}
			{content.mainImage?.type && (
				<MainImages
					competitor={competitor}
					competitorName={fullCompetitorName || competitor}
					imageType={content.mainImage.type}
				/>
			)}
			{content.comparisonHeader && (
				<ComparisonHeader
					titleKey={content.comparisonHeader.titleKey}
					subtitleKey={content.comparisonHeader.subtitleKey}
				/>
			)}
			{content.comparisonColumns && (
				<ComparisonColumns
					competitor={competitor}
					fullCompetitorName={fullCompetitorName}
					features={content.comparisonColumns.features}
				/>
			)}
			{content.tableComparison && (
				<TableComparison
					competitor={competitor}
					fullCompetitorName={fullCompetitorName}
					titleKey={content.tableComparison.titleKey}
					subtitleKey={content.tableComparison.subtitleKey}
					features={content.tableComparison.features}
				/>
			)}
			<BlogsBlock />
			<CTARow
				title={<Translation tid="landingMainPage.cta.title" />}
				subtitle={<Translation tid="landingMainPage.cta.body" />}
				cta={
					<SignupEmailPage isLandingPage isCustomLanding autoFocus={false} />
				}
			/>
		</div>
	);
};

export default StreamYardVsCompetitor;
